import React, { useEffect, useState } from "react";
import { styled } from "@mui/system";
import { Link, useParams } from "react-router-dom";
import "./common.css";
import API_URL from "../common/Apiurl";

function Viewprovider() {
  const apiUrl = API_URL;
  const [items, setItems] = useState([]);
  const [averagedata, setAveragedata] = useState([]);
  const viewId = useParams();
  const tradesmanId = viewId.providerid;

  useEffect(() => {
    const getComments = async () => {
      try {
        const postData = {
          tradesman_id: tradesmanId,
        };
        const res = await fetch(`${apiUrl}/admin/viewtradesman`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(postData),
        });
        const data = await res.json();
        if (data.status !== 200) {
          throw new Error("Data not found");
        }
        setItems(data.data);
        setAveragedata(data.average);
      } catch (error) {
        console.error("Error ", error);
      }
    };
    getComments();
  }, []);
  return (
    <div className="width90">
      <h2 className="pageTitle">View Provider Details</h2>
      <div className="commonCntr">
        <form className="form-horizontal" action="">
          <div className="form-group">
            <label className="control-label col-sm-2 label">Name:</label>
            <div className="col-sm-4 mt-1">
              <span>{items.name}</span>
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">
              Email address:
            </label>
            <div className="col-sm-4 mt-1">
              <span>{items.email}</span>
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Address:</label>
            <div className="col-sm-4 mt-1">
              <span>{items.home_address}</span>
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-12 label">Reviews:</label>
            <label className="control-label col-sm-2 label">
              Communication:
            </label>
            <div className="col-sm-4 mt-1">
              <span>{averagedata.averageComm}/5</span>
              <span className="d-block">
                reviews given by {averagedata.commUsers} users.
              </span>
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Knowledge:</label>
            <div className="col-sm-4 mt-1">
              <span>{averagedata.averageknowledge}/5</span>
              <span className="d-block">
                reviews given by {averagedata.knowledgeUsers} users.
              </span>
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">
              Transparency:
            </label>
            <div className="col-sm-4 mt-1">
              <span>{averagedata.averagetransparency}/5</span>
              <span className="d-block">
                reviews given by {averagedata.transparencyUsers} users.
              </span>
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Cleanliness:</label>
            <div className="col-sm-4 mt-1">
              <span>{averagedata.averagecleanliness}/5</span>
              <span className="d-block">
                reviews given by {averagedata.cleanlinessUsers} users.
              </span>
            </div>
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">
              Professionalism:
            </label>
            <div className="col-sm-4 mt-1">
              <span>{averagedata.averageprofessionalism}/5</span>
              <span className="d-block">
                reviews given by {averagedata.professionalismUsers} users.
              </span>
            </div>
          </div>
          {items?.documents?.map((e) => {
              return (
                <div className="form-group mt-4">
                  <label className="control-label col-sm-3 label">
                    Document Approval Status
                  </label>
                  <input
                    type="checkbox"
                    id="driving_licence"
                    name="driving_licence"
                    checked={e.status}
                  />{" "}
                  <label className="control-label col-sm-2 label">
                    {e.type === "driving_licence" ? "Driving Licence" : "Address Documents"}
                  </label>
                  <div className="col-sm-4  mt-1">
                    <iframe
                      src={e.image}
                      // class="img-fluid small-image"
                      alt="No Document uploaded yet"
                    ></iframe>
                    <a target="_blank" href={e.image}>Preview</a>
                  </div>
                </div>
              );
          })}
          
          <div className="form-group mt-4">
            <div className="row">
              <div className="col">
                  <Link to={`/admin/alljobs/hired/${tradesmanId}`}>Hired Jobs</Link>
              </div>
              <div className="col">
                  <Link to={`/admin/alljobs/applied/${tradesmanId}`}>Jobs Applied</Link>
              </div>
              <div className="col">
                  <Link to={`/admin/alljobs/completed/${tradesmanId}`}>Completed jobs</Link>
              </div>
              <div className="col">
                  <Link to={`/admin/alljobs/completed/${tradesmanId}`}>Credits</Link>
              </div>
              <div className="col">
                  <Link to={`/admin/wallet/transactionhistory/${tradesmanId}`}>Wallets</Link>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Viewprovider;
